exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "#content-map-outlet .active-button{background-color:#0086ff;color:#fff}#content-map-outlet .danger-button{background-color:#f86c6b;color:#fff}", "", {"version":3,"sources":["/home/circleci/phdva/ui/src/views/admin/outlets/OutletsMap.vue"],"names":[],"mappings":"AACA,mCACC,yBAA0B,AAC1B,UAAa,CACb,AACD,mCACC,yBAA0B,AAC1B,UAAa,CACb","file":"OutletsMap.vue","sourcesContent":["\n#content-map-outlet .active-button {\n\tbackground-color: #0086FF;\n\tcolor: white;\n}\n#content-map-outlet .danger-button {\n\tbackground-color: #f86c6b;\n\tcolor: white;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-69588b5b","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/views/admin/outlets/OutletsMap.vue
// module id = 1818
// module chunks = 0